<template>
	<v-dialog scrollable persistent v-model="dialog" @click:outside="closeDialog()" @keyup.esc="closeDialog()" max-width="500">
		<v-card>
			<v-card-title>
				Szczegóły zgłoszenia
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text>
				<div class="text-muted">Data zgłoszenia:</div>
				<div class="bold font-14 text-black">{{ $moment(abuse.created_at).format('LLL') }}</div>
				<div class="text-muted mt-3">Status:</div>
				<v-chip
					small
					:class="status.class"
				>
					{{ status.text }}
				</v-chip>
				<div class="text-muted mt-3">Powód:</div>
				<div class="bold font-14 text-black">{{ abuse.reason }}</div>
				<div class="text-muted mt-3 mb-2">Osoba zgłaszająca:</div>
				<div class="d-flex align-items-center">

					<content-hover :user="abuse.user" avatar class="mr-3 mt-3"/>
					<div class="ml-2">
						<content-hover :user="abuse.user" hover-class="d-flex flex-row bold font-14" user-name/>
						<div v-if="abuse.user.job_position" class="small">{{ abuse.user.job_position }}</div>
					</div>
				</div>
			</v-card-text>
			
			<v-card-actions class="text-center justify-content-center py-3">
				<div v-if="abuse.status == 'waiting'" class="text-center abuse-action mt-3">
					<v-btn :loading="saving.rejected" @click="conside('rejected')" class="btn-success mr-5" plain><v-icon>mdi-check</v-icon> Zachowaj wpis</v-btn>
					<v-btn :loading="saving.accepted" @click="conside('accepted')" class="btn-error" plain><v-icon class="mr-1">$trash</v-icon> Usuń wpis</v-btn>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import ContentHover from "@/components/items/ContentHover";

export default {
	components: {
		ContentHover,

	},
	props: {
		abuse: {
			type: Object,
			required: true
		},
		status: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			dialog: true,
			saving: {
				accepted: false,
				rejected: false
			}
		}
	},
	methods: {
		closeDialog() {
			this.$emit('close');
		},
		async conside(status) {
			this.saving[status] = true;
			let res = await this.$store.dispatch('abuses/consideAbuse', {
				id: this.abuse.id,
				status: status
			});
			if(res.success) {
				this.$snackbar.success("Pomyślnie zapisano zmiany");
				this.$store.commit('abuses/removeAbuse', this.abuse);
				this.closeDialog();
			}
			else {
				this.$snackbar.error({error: res.error});
			}
			this.saving[status] = false;
		}
	}
}
</script>